import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import hardwareImage from "../../assets/images/operating.avif"; 
import hardwareImage from "../../assets/images/immersivehealthare.png"; 


const WhatWeOffer = () => {
  return (
    <div className="offer-section">
      <Container>
        <Row className="align-items-center">
              <h2 className="mxr__section-title text-uppercase text-center" >What We Offer</h2>
          <Col md={6}>
            <div className="offer-text">
              <h4>Hardware Upgrades:</h4>
              <p>We can enhance your existing immersive setup or provide better solutions, including:</p>
              <ul>
                <li>
                  <strong>The latest ultra short throw projectors</strong> that enhance visual clarity 
                  and performance.
                </li>
                <li>
                  <strong>Advanced tracking and gesture technology</strong> for seamless interaction.
                </li>
                <li>
                  <strong>Improved touch technology</strong> for pin-point responsiveness and ease of use.
                </li>
              </ul>
            </div>
          </Col>

          <Col md={6}>
            <div className="offer-image">
              <img src={hardwareImage} alt="Hardware Upgrade" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WhatWeOffer;
